import Vue from 'vue';

import moment from 'moment';
import {
	debounce,
	every,
	// 	filter,
	// 	findLastIndex,
	isEmpty,
	isFunction,
} from 'lodash-es';

const crawlerRegex = /bot|googlebot|crawler|spider|robot|crawling|google page speed/i;

// Setup $iUtils as plugin so it can be used in router
const ireloUtils = {
	install: function(Vue) {
		const utils = {
			debounce,
			every,
			// filter,
			// findLastIndex,
			isEmpty,
			isFunction,
			isWebCrawler:
				navigator.userAgent && crawlerRegex.test(navigator.userAgent),
			moment,
		};

		Vue.$iUtils = utils;
		Vue.prototype.$iUtils = utils;
	},
};

Vue.use(ireloUtils);

Vue.config.devtools = process.env.VUE_APP_DEBUG === 'true';
Vue.config.productionTip = process.env.VUE_APP_DEBUG === 'true';
